import { render, staticRenderFns } from "./ModulosCarrousel.vue?vue&type=template&id=48d93e10&scoped=true"
import script from "./ModulosCarrousel.vue?vue&type=script&lang=js"
export * from "./ModulosCarrousel.vue?vue&type=script&lang=js"
import style0 from "./ModulosCarrousel.vue?vue&type=style&index=0&id=48d93e10&prod&lang=scss"
import style1 from "./ModulosCarrousel.vue?vue&type=style&index=1&id=48d93e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d93e10",
  null
  
)

export default component.exports